'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal, GenericModalButton } from 'com-gyf-webcore-userinterfacecomponents';
import 'rc-dialog/assets/bootstrap.css';
import ModalHeader from './HeaderInfo'
import ModalBody from './BodyModalInfo'
import FooterButtons from './FooterButtons'
import { PersonaFisicaMock, PersonaJuridicaMock } from './ClienteMock'

class NuevaSolicitud extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            personaFisica: true 
        };
        this.changeCliente = this.changeCliente.bind( this )
    }
    changeCliente() {
        this.setState( { personaFisica: !( this.state.personaFisica ) } )
    }
    render() {
        return (
            <div className="modal fade-out" id={this.props.idModal ? this.props.idModal : "SolicitudAltaDeCuenta"} role="dialog" data-backdrop="static">
                {!this.props.loadingCliente &&<div className="modal-dialog modal-info-alta-individuo">
                    <div className="modal-content">
                        <ModalHeader handleClick={this.changeCliente}
                            titular={!this.props.esAdicional}/*cambia el mensaje del header dependiendo si es cliente titular o extension*/
                            soloDatos={this.props.soloDatos}
                        />
                        {this.props.cliente && <ModalBody cliente={this.props.cliente}
                            soloDatos={this.props.soloDatos}
                            titular={true}
                        />}
                        {!this.props.soloDatos&&<FooterButtons
                            redirect={this.props.redirect}
                            callback={this.props.callback}
                        />}
                    </div>
                </div>}
            </div >
        )
    }
}
export default NuevaSolicitud;
{//<GenericSimpleButton text="No" buttonClass="btn btn-secondary float-right" onClick={() => { this.props.toggleModal(); this.props.aceptModalCuentas() }} />
}